import React from 'react';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import FetchSelectV2 from '../../../core/form/FetchSelectV2';
import get from 'lodash/get';
import TextInput from '../../../core/form/TextInput';
import PropTypes from 'prop-types';
import MaskInput from '../../../core/form/MaskInput';
import DateInput from '../../../core/form/DateInput';
import Select from '../../../core/form/Select';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import { browserHistory } from 'react-router';
import LocalFileInput from '../../../core/form/LocalFileInput';
import { BRAZIL } from '../../../core/consts';
import PostPaymentContractProductsList from './PostPaymentContractProductsList';
import UpfrontContractProductsList from './UpfrontContractProductsList';
import Divider from '../../../core/layout/Divider';
import ContractOpenBillsContainer from './ContractOpenBillsContainer';
import Separator from '../../../core/layout/Separator';

const ContractDetail = (props) => {
  return (
    <Card
      collapsible
      title="Contract Info"
      loading={props.loading}
      actions={
        <span style={{ marginRight: 10 }}>
          <Button icon="arrow-left" label="Back" type="default" onClick={() => browserHistory.goBack()} />
        </span>
      }
    >
      <Row>
        <Column size={4}>
          <TextInput
            floatingLabel
            fullWidth
            disabled
            label="Client Name"
            value={get(props.values, 'contactName', '')}
          />
        </Column>
        <Column size={4}>
          <DateInput disabled label="Client Birth Date" value={get(props.values, 'contactBirthDate', null)} />
        </Column>
        <Column size={1}>
          <Select
            label="Client Gender"
            disabled
            value={get(props.values, 'contactGender', null)}
            onChange={(value) => props.onChange('contactGender', value)}
            options={[
              { value: 'M', label: 'Masculine' },
              { value: 'F', label: 'Feminine' },
            ]}
          />
        </Column>
      </Row>

      <Row>
        <Column size={3}>
          <FetchSelectV2
            required
            showSearch
            url="countries"
            apiVersion="v3"
            disabled
            label="Country"
            value={get(props.values, 'country', '')}
            resultTransformer={{
              text: 'name',
              value: 'id',
            }}
          />
        </Column>
        <Column size={3}>
          <FetchSelectV2
            required
            showSearch
            url="states"
            apiVersion="v3"
            params={{
              ...(get(props.values, 'country', false) && {
                country: get(props.values, 'country', ''),
              }),
            }}
            disabled
            label="State"
            value={get(props.values, 'state', '')}
            resultTransformer={{
              text: 'name',
              value: 'id',
            }}
          />
        </Column>
        <Column size={6}>
          <TextInput floatingLabel fullWidth disabled label="City" value={get(props.values, 'city', '')} />
        </Column>
      </Row>
      <Row>
        <Column size={4}>
          {BRAZIL.includes(props.values.country) ? ( // Brazil
            <MaskInput
              disabled
              label="CPF/CNPJ"
              value={get(props.values, 'documentNumber', '')}
              delimiters={['.', '.', '/', '-']}
              blocks={[2, 3, 3, 4, 2]}
              numericOnly
              required
            />
          ) : (
            <TextInput required disabled label="Document Number" value={get(props.values, 'documentNumber', '')} />
          )}
        </Column>
        <Column size={8}>
          <TextInput disabled required label="Social Reason" value={get(props.values, 'socialReason', '')} />
        </Column>
      </Row>
      <Row>
        <Column size={4}>
          <TextInput
            floatingLabel
            required
            fullWidth
            disabled
            label="Address"
            value={get(props.values, 'address', '')}
          />
        </Column>
        <Column size={4}>
          <TextInput
            floatingLabel
            required
            fullWidth
            disabled
            label="District"
            value={get(props.values, 'district', '')}
          />
        </Column>
        <Column size={4}>
          <MaskInput
            disabled
            required
            label="Number"
            value={get(props.values, 'number', null)}
            blocks={[9]}
            numericOnly
          />
        </Column>
      </Row>
      <Row>
        <Column size={4}>
          <TextInput
            floatingLabel
            required
            fullWidth
            disabled
            label="Zip code"
            value={get(props.values, 'zipCode', '')}
          />
        </Column>
        <Column size={4}>
          <Select mode="tags" required disabled label="Emails" value={get(props.values, 'emails', [])} />
        </Column>
        <Column size={4}>
          <MaskInput
            floatingLabel
            fullWidth
            disabled
            label="Phone"
            value={get(props.values, 'phone', '')}
            maskType="phone"
          />
        </Column>
      </Row>
      <Row>
        <Column size={2}>
          <Select
            mode="multiple"
            required
            disabled
            label="Allowed Payment Methods"
            value={get(props.values, 'allowedPaymentMethods', [])}
            options={[
              { value: 'CREDIT_CARD', label: 'Credit Card' },
              { value: 'BANK_SLIP', label: 'Bank Slip' },
              { value: 'PIX', label: 'Pix' },
            ]}
          />
        </Column>
        <Column size={1}>
          <TextInput
            floatingLabel
            fullWidth
            disabled
            label="Hubspot Deal Id"
            value={get(props.values, 'hubspotDealId', '')}
          />
        </Column>
        <Column size={1}>
          <Select
            disabled
            label="Type"
            value={get(props.values, 'type', null)}
            options={[
              { value: 'UPFRONT', label: 'Upfront' },
              { value: 'POST_PAYMENT', label: 'Post Payment' },
            ]}
          />
        </Column>
        <Column size={2}>
          <DateInput disabled label="Contract starts in" value={get(props.values, 'startsAt', null)} />
        </Column>
        <Column size={2}>
          <DateInput disabled label="Contracts ends in" value={get(props.values, 'endsAt', null)} />
        </Column>
        <Column size={1}>
          <Select
            label="Due day"
            disabled
            value={get(props.values, 'dueDay', '')}
            options={[...Array(31).keys()].map((n) => ({
              label: n + 1,
              value: n + 1,
            }))}
          />
        </Column>
        <Column size={3}>
          <LocalFileInput
            value={get(props.values, 'contractFile', null) || get(props.values, 'contractUrl', null)}
            label="Upload the contract"
            accept="pdf"
            disabled
          />
        </Column>
      </Row>
      <Row>
        <Column size={3}>
          {!get(props.values, 'isDistributor', false) && (
            <FetchSelectV2
              showSearch
              url="companies"
              apiVersion="v3"
              disabled
              label="Company"
              value={get(props.values, 'company', null)}
              placeholder="Create a new company"
              resultFilter={(company) => company.id === get(props.values, 'company', null) || !company.contract}
              resultTransformer={{
                text: 'name',
                value: 'id',
              }}
            />
          )}
          {get(props.values, 'isDistributor', false) && (
            <FetchSelectV2
              showSearch
              required
              url="distributors"
              apiVersion="v3"
              disabled
              label="Distributor"
              value={get(props.values, 'distributor')}
              resultTransformer={{
                text: 'name',
                value: 'id',
              }}
              resultFilter={(distributor) =>
                distributor.contract === get(props.values, 'id', null) || !distributor.contract
              }
            />
          )}
        </Column>
      </Row>
      <Divider title="Current Products" />
      <Row>
        <Column size={12}>
          {props.values.type === 'UPFRONT' && (
            <UpfrontContractProductsList
              readOnly
              data={props.values.products}
              currencyType={BRAZIL.includes(props.values.country) ? 'real' : 'dollar'}
            />
          )}
          {props.values.type === 'POST_PAYMENT' && (
            <PostPaymentContractProductsList
              data={props.values.products}
              currencyType={BRAZIL.includes(props.values.country) ? 'real' : 'dollar'}
              readOnly
            />
          )}
        </Column>
      </Row>
      {props.showOpenBills && (
        <>
          <Separator />
          <Divider title="Open Bills" />
          <Row>
            <Column size={12}>
              <ContractOpenBillsContainer contractId={props.values.id} />
            </Column>
          </Row>
        </>
      )}
    </Card>
  );
};

ContractDetail.propTypes = {
  values: PropTypes.object,
  loading: PropTypes.bool,
  showOpenBills: PropTypes.bool,
};

ContractDetail.defaultProps = {
  values: {},
  loading: false,
  showOpenBills: false,
};

export default ContractDetail;
